import { ModelAdvertParametersInterface } from './types'

export const getModelAdvertAliasURLPart = ({ model, advertiserAlias }: ModelAdvertParametersInterface) => `${advertiserAlias}/${model}`

export const getModelAdvertAliasRESTApiParameter = ({ model, advertiserAlias }: ModelAdvertParametersInterface) => `${advertiserAlias}_${model}`
